import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createPortalApi } from "./api/client.ts";
import { App } from "./App.tsx";
import { shellAuth } from "./auth/session.ts";
import "./styles/theme.css";

const auth = shellAuth();
const api = createPortalApi(auth);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App auth={auth} api={api} />
  </StrictMode>,
);
